import { useState } from 'react';
import { HomeScreen } from './HomeScreen';

import { MissionStore, MissionStoreProvider } from '../../../../store';
import {
  NachversandStore,
  NachversandStoreProvider,
} from '../../../../store/NachversandStore';

export const HomeScreenWrapper = () => {
  // created once per mount, not per render
  const [nachversandStore] = useState(() => new NachversandStore());

  return (
    <MissionStoreProvider store={new MissionStore()}>
      <NachversandStoreProvider store={nachversandStore}>
        <HomeScreen />
      </NachversandStoreProvider>
    </MissionStoreProvider>
  );
};
